import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Translate } from "react-redux-i18n";
import { KCheck } from "../../KCheck";
import { ColumnType } from "../../kptable";
import { tooltipate } from "../../../index";
export const TableHeader = ({ id, children, checkboxes, globalChecked, onChangeGlobalCheck, loaderFunc, data, keyField, columnVisibility, variableColumns }) => {
    const style = { textTransform: "uppercase" };
    return (_jsx("thead", { className: "kpheading", children: _jsxs("tr", { children: [checkboxes ? (_jsx("th", { className: "checkboxes", children: _jsx(KCheck, { id: `${id}-globalcheck`, label: "", type: "checkbox", checked: globalChecked, onChange: () => onChangeGlobalCheck(id, !globalChecked, data, keyField) }) })) : null, React.Children.map(children, (child, index) => {
                    const { name, description, type, colspan, classes, colid, hideable = true } = child.props;
                    if (!columnVisibility[colid] && hideable) {
                        return null;
                    }
                    return (_jsx("th", { style: { ...style }, children: name
                            ? tooltipate(_jsx("div", { className: classes, children: _jsx(Translate, { value: name }) }), description)
                            : null }, index));
                }), variableColumns
                    ? variableColumns.columns.map((column, childIndex) => {
                        return columnVisibility[column] ? (_jsx("th", { style: { ...style, ...{ cursor: "pointer" } }, children: column }, childIndex)) : null;
                    })
                    : null, React.Children.map(children, (child, index) => {
                    const { type, name, classes, colspan, description } = child.props;
                    const classNames = classes || "";
                    if (type !== ColumnType.ACTIONS) {
                        return null;
                    }
                    let tdWidth = "";
                    if (colspan) {
                        tdWidth = `${(100 / 12) * colspan}%`;
                    }
                    return (_jsx("th", { style: { ...style, paddingRight: 25, width: tdWidth }, children: name
                            ? tooltipate(_jsx("div", { className: classNames, children: _jsx(Translate, { value: name }) }), description)
                            : null }, index));
                })] }) }));
};
